import { render } from "./competence-main.vue?vue&type=template&id=6ec00ffa&scoped=true"
import script from "./competence-main.vue?vue&type=script&lang=js"
export * from "./competence-main.vue?vue&type=script&lang=js"

import "./competence-main.vue?vue&type=style&index=0&id=6ec00ffa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ec00ffa"],['__file',"src/components/applications/competence/competence-main.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ec00ffa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ec00ffa', __exports__)) {
    api.reload('6ec00ffa', __exports__)
  }
  
  module.hot.accept("./competence-main.vue?vue&type=template&id=6ec00ffa&scoped=true", () => {
    api.rerender('6ec00ffa', render)
  })

}


export default __exports__